import './App.css';
import me from './assets/platinum.jpg'
import whatIdo from './assets/71619-coding.gif'
import intro from './assets/93626-coding.gif'
import pdf from './Resume-Adesina-Emmanuel.pdf'
import { useEffect } from 'react';

export default function App() {

  const educations = [
    {
      'school': 'FEDERAL UNIVERSITY OF TECHNOLOGY, AKURE.',
      'grade': 'B. Sc (Second Upper Honors)',
      'course': 'Industrial Mathematical Science.',
      'when': 'Nov. 2015 - Oct. 2021'
    },
    // {
    //   'school': 'SQI Academy',
    //   'grade': 'Web Development Associate',
    //   'when': '2012 - 2014'
    // },
  ]

  const skills = [
    'PHP', 'Laravel', 'NextJs', 'React', 'React Native', 'REST API',
    'SQL', 'MySQL', 'WebRTC', 'HTML5', 'CSS', 'SASS', 'TailwindCSS',
    'NodeJs', 'ExpressJS', 'Cordova'
  ]

  const projects = [
    {
      'name': 'Mantenar',
      'desc': 'An organization file sharing PWA, installable on any PHP enabled server. With Real Time Chat',
      'tech': ['Laravel 9', 'SingleStore DB', 'NextJs', 'Laravel Websocket'],
      'repo': 'https://github.com/ThePlatinum/app.mantenar',
      'live': 'https://mantenar.com'
    },
    {
      'name': 'ProsUP.xyz',
      'desc': 'A platform for students to share their project works and school resources, particularly for undergraduates.',
      'tech': ['React', 'PHP', 'MySQL', 'EmailJs'],
      'repo': 'https://github.com/ThePlatinum/ProsUp',
      'live': 'https://prosup.xyz/'
    },
    {
      'name': 'Kollegio LMS',
      'desc': 'Learing platform for secondary schools, with class resource (lecture notes, videos, and PDF) sharing from teachers and CBT Practice. Supporting roles for Admin, teacher and students',
      'tech': ['Laravel 9', 'Javascript', 'JQuery', 'Bootstrap'],
      'repo': 'https://github.com/ThePlatinum/kollegio',
      'demo': 'https://kollegio.mantenar.com/'
    },
    {
      'name': 'EduAT School Management System',
      'desc': 'A school management platform for school adminstratives, students and teachers.',
      'tech': ['Laravel 8', 'Bootstrap'],
      'repo': 'https://github.com/ThePlatinum/eduat',
      'demo': 'https://eduat.herokuapp.com/'
    },
    {
      'name': 'Cubie NFT Minting Contract',
      'desc': 'Cubie NFT minting page and TRC721 contract',
      'tech': ['NextJs', 'Solidity', 'Web3', 'TRC721'],
      'repo': 'https://github.com/ThePlatinum/cubie-mint',
      'live': 'https://mint.cubie.art/'
    },
    {
      'name': 'english-permutation',
      'desc': 'A open source NPM package that generates all possible permutations of a given string',
      'tech': ['NodeJs', 'JavaScript'],
      'repo': 'https://github.com/ThePlatinum/english-permutation',
      'live': 'https://www.npmjs.com/package/english-permutation'
    },
    {
      'name': 'Iyanju',
      'desc': 'A simple Mobile Application that shows daily motivational words',
      'tech': ['React Native', 'React', 'Laravel 8'],
      'repo': 'https://github.com/ThePlatinum/iyanju',
    }
  ]

  const work = [
    {
      'name': 'ActionPointer Ltd',
      'role': 'Mobile Developer',
      'location': 'Remote (Contract)',
      'when': 'Nov., 2022 - Mar. 2023',
      'responsibilities': [
        'Developed an E-Commerce cross-platform mobile application using React Native',
        "Worked closely with other developers to create APIs in Laravel and consume them on the mobile App",
        "Suggested and implemented UI component designs for smooth user interaction and experience",
        "Worked remotely with no supervision and made timely delivery."
      ]
    },
    {
      'name': 'Publicity Drive',
      'role': 'Full Stack Developer',
      'location': 'Remote (Contract)',
      'when': 'Feb., 2022',
      'responsibilities': [
        'Conceptualization and development of the flagship product ISE, a Freelance platform focused on the African populace using Laravel 9 and InertiaJS React option',
        "Co-designed UI components and workflows to ensure a smooth user experience using Figma.",
        "Worked remotely without supervision"
      ]
    },
    {
      'name': 'Petrong Software Solutions',
      'role': 'Full Stack Developer and Technical Tean Lead',
      'location': '36, Fadare, Ogba, Lagos (Hybrid - Full Time)',
      'when': 'Dec. 2021 - Nov. 2022',
      'responsibilities': [
        "Lead a team of 26 developers to execute projects from start to finish. Performing task allocations, code review and debugging via GitHub maintaining code quality Project evaluations, reports and technical decision-making.",
        "Conceptualization of project ideas and writing specifications for development and overseeing the entire Software Development Life Cycle of over 4 projects including Servolution, an e-commerce platform that allows people to find artisans in their locality, Kollegio, a feature-rich LMS Platform for secondary schools, and DeftPress, a growing CMS for easy website creation for bloggers. ",
        "Worked in a hybrid culture with no supervision and contributed well to my team's growth.",
        "Built Dawn Mobile, a cross-platform mobile application using Cordova, for Churches to easily keep track of their converts, with live chat and instant notification features",
        "Maintained and improved Pacioli, a customer onboarding and loan management application for Micro Finance Banks. ",
        "Built Admin Dashboards in PHP/Laravel and REST APIs for products like Pacioli and Dawn Mobile.",
      ]
    },
    {
      'name': 'Blended Learning and Study Center',
      'role': 'Full Stack Developer and Instructor',
      'location': 'Connecticut (Remote - Part Time)',
      'when': 'Mar. 2020 - Jan. 2023',
      'responsibilities': [
        "Full conceptualization and development of EduTech products",
        "Built Onicha Dialect Mobile App in React Native",
        "Build a Podcast Platform with RSS that feeds to Google, Apple, and Spotify Podcast with Admin Dashboard",
        "Built Onicha Language Learning Platform with subscription-based access to video resources and the Onicha Ado Dialect Dictionary",
        "Built the BLSC student portal"
      ]
    },
  ]

  useEffect(() => {
    document.addEventListener("scroll", () => {
      let header = document.querySelector('.Header');
      if (window.scrollY > 80) {
        header?.classList.add('scrolled');
      } else {
        header?.classList.remove('scrolled');
      }
    });
  }, [])

  const socials = () => {
    return (
      <div className="socials-hold">
        <a target='_blank' href='https://www.github.com/ThePlatinum' rel="noreferrer"><i className='bx bxl-github icon'></i></a>
        <a href='mailto:platinumemirate@gmail.com'><i className='bx bx-envelope icon'></i></a>
        <a target='_blank' href='https://www.linkedin.com/in/platinum-emmanuel' rel="noreferrer"><i className='bx bxl-linkedin icon'></i></a>
        <a href='tel:+2347014293952'><i className='bx bx-mobile icon'></i></a>
      </div>
    )
  }

  return (
    <>
      <div className='head'>
        <div className='Header'>
          <h1 className='mainname'>
            Emmanuel A. Adesina
          </h1>
          <div>
            {socials()}
          </div>
        </div>
        <div className='section' >
          <div className='d-flex'>
            <div className='t-center pr-5'>
              <p>Hi,</p>
              <h2>I am Emmanuel</h2>
              <p>
                Self-taught and highly motivated full-stack developer with a passion for excellence and a strong determination to succeed.
                Skilled in PHP, Laravel, HTML5, JavaScript, React, and more, with a proven track record of developing web and mobile
                applications. With a determination to contribute to my community, I have contributed to open-source projects and helped to
                train other developers.
                <br />
                <br />
                Motivated by a passion for excellence and a strong determination to develop into a highly successful professional with core
                values centered around commitment and teachability.
              </p>
              <div className='action'>
                <div className='my-5'>
                  <a href={pdf} className='btn' type="application/pdf" download="Emmanuel_Adesina_CV" > <i className='bx bx-note'></i> See My Resume</a>
                </div>
                {socials()}
              </div>
            </div>
            <div className='m-hide'>
              <img src={intro} alt='Coding GIF' className='l-image' />
            </div>
          </div>
        </div>
      </div>

      <div className='section whatIdo'>
        <div className='d-flex'>
          <div className='pr-5'>
            <img src={whatIdo} alt='Coding GIF' className='l-image' />
          </div>
          <div>
            <h2 className='text-md-white'>What I do?</h2>
            <h3 className='text-md-white'>Full Stack Development</h3>
            <div className='d-grid'>
              {skills.map((i) => {
                return (
                  <div className='g-item' key={i}>
                    <div className='pills'> {i} </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>

      <div className='section education'>
        <div className='title d-grid'>
          <i className='bx bxs-graduation'></i> Education
        </div>
        <div className='d-flex'>
          {educations.map((e, i) => {
            return (
              <div className='f-item' key={i}>
                <div className='card'>
                  <h3 className='text-bold'> {e.school} </h3>
                  <small> {e.when} </small>
                  <p> {e.grade} <br/> {e.course} </p>
                </div>
              </div>
            )
          })}
        </div>
      </div>

      <div className='section projects'>
        <div className='title d-grid'>
          <i className='bx bx-laptop'></i> Projects
        </div>
        <div className='d-flex d-flexed'>
          {projects.map((e, i) => {
            return (
              <div className='f-item' key={i}>
                <div className='card'>
                  <div>
                    <h3> {e.name} </h3>
                    <div className='d-grid'>
                      {e.tech.map((t, i) => { return (<div className='tech' key={i}> {t} </div>) })}
                    </div>
                    <h5> {e.desc} </h5>
                    <div className='d-grid'>
                      <div className='g-item'>
                        <a className='btn-git' href={e.repo}><i className='bx bxl-github'></i></a>
                      </div>
                      <div className='g-item'>
                        {e.demo ? <a className='btn-demo' href={e.demo} target='_blank' rel="noreferrer">Demo</a> : ''}
                        {e.live ? <a className='btn-live' href={e.live} target='_blank' rel="noreferrer">Live</a> : ''}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>

      <div className='backgrund'></div>

      <div className='section experience'>
        <div className='title d-grid'>
          <i className='bx bx-briefcase-alt-2'></i>Work Experiences
        </div>
        <div className='d-flex d-flexed' style={{ alignItems: 'flex-start' }}>
          {work.map((e, i) => {
            return (
              <div className='w-full' key={i}>
                <div className='card'>
                    <h3 className='text-bold' style={{margin: 0}}> {e.name} </h3>
                    <p>{e.role} | {e.when}</p>
                    <ul>
                    {e.responsibilities.map((t, i) => {
                      return (
                        <li key={i}> {t} </li>
                      )
                    })}
                    </ul>
                </div>
              </div>
            )
          })}
        </div>
      </div>

      <div className='foot'>
        <div className='Footer'>
          <div className='f-left'>
            <h1>Emmanuel Adedayo, Adesina</h1>
            <h2>Lagos, Nigeria</h2>
            {socials()}
          </div>
          <div>
            <img src={me} alt="Emmanuel Adesina" />
          </div>
        </div>
      </div>
    </>
  )
}
